import { get } from 'lodash-es';

export const getThumbnail = (props) => {
  const small = get(props, ['thumbnail_small', 'url']);
  const regular = get(props, ['thumbnail', 'url']);

  return small || regular || '';
};
